import React from 'react'
import './style.css'

export default function product() {
    
    function toMoney(x) {
        return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    }
    return (
        <div className="barang-product">
            <h2>Barang Pesanan Anda</h2>
            <div className="product-pengirim">
                <h3>Cordova</h3>
                <small>Makassar</small>
                {
                    Product.map((data, i) => {
                        return (
                            <div key={i} className="product">
                            <img src={data.src} alt="kitab" />
                            <div className="product-text">
                            <h3>{data.name_book}</h3>
                                <div className="alamat-product">
                                    <div className="text">
                                        <p>{data.cover}</p>
                                        <p>{data.total}</p>
                                        <p>{data.cut_price}</p>
                                    </div>
                                    <div className="price">
                                        <small>{data.cut_price}</small>
                                        <h3>{toMoney(data.price)}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    })
                }
                <div className="border"></div>
                <div className="harga-barang">
                    <p>Harga Barang</p>
                    <p>Rp. 140.000</p>
                </div>
                <div className="harga-barang">
                    <p>Ongkos Kirim</p>
                    <p>Rp. 20.000</p>
                </div>
                <div className="harga-barang">
                    <h6>Subtotal</h6>
                    <h3>Rp. 160.000</h3>
                </div>
            </div>
        </div>
    )
}

const Product = [
    {src:"asset/product/kitab.png", name_book:"Kitab Riyadhusshalihin Karya Imam ...", cover:"Hardcover", total:"Jumlah di pesan (1)", size:"Berat 70g", cut_price:"Rp.160.000", price:"120000"}, {src:"asset/product/notiv.png", name_book:"Buku Saku - Dzikir Pagi dan Petang ...", cover:"Softcover", total:"Jumlah di pesan (3)", size:"Berat 5g", cut_price:"Rp.25.000", price:"20000"}
]

